import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { login, logout } from "../../../services/tokenService";
import { ISessionState } from "../../session/sessionState";
import { AppDispatch } from "../store";
import { clearStore } from "./appSlice";

const initialState: ISessionState = {
    id: "",
    userName: "",
    fullName: "",
    accessToken: "",
    refreshToken: "",
    refreshTime: 0,
    employeeGroupParameters: null,
    defaultCulture: ""
};

export const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        setAccessToken: (state, action: PayloadAction<string>) => {
            state.accessToken = action.payload;
        },
        setSession: (state, action: PayloadAction<ISessionState>) => {
            return { ...state, ...action.payload };
        },
        clearSession: (state) => {
            return { ...state, ...initialState };
        }
    },
});

export const { setAccessToken, setSession, clearSession } = sessionSlice.actions;

export const handleLogin = (user : string, pass : string) => async(dispatch: AppDispatch) => {
    dispatch(clearStore()); // Clear store to start with fresh data.
    const sessionData = await login(user, pass);
    dispatch(setSession(sessionData));
};

export const handleLogout = (cb: () => void) => async(dispatch: AppDispatch) => {
    await logout();
    dispatch(clearStore()); // Clear store to start with fresh data.
    cb();
};

export const sessionReducer = sessionSlice.reducer;
